import {
  CREDIT_PACK_CREDITS,
  CREDIT_PACK_PRICE_CENTS,
  CREDIT_PACK_PRICE_DOLLARS,
  CREDIT_PACK_PRICE_LABEL,
  CREDIT_PACK_EUR_PRICE_LABEL,
  getCreditPackPriceId,
  type A2gBillingMarket,
} from "./billing-config";

export const CREDIT_PACK_PRICE_ID = getCreditPackPriceId();
export const CREDIT_PACK_EUR_PRICE_ID = getCreditPackPriceId("sepa");

export function creditPackConfigured(market: A2gBillingMarket = "global"): boolean {
  return (market === "sepa" ? CREDIT_PACK_EUR_PRICE_ID : CREDIT_PACK_PRICE_ID).length > 0;
}

export function creditsForPriceId(priceId: string | null | undefined): number {
  if (!priceId) return 0;
  if (
    (creditPackConfigured() && priceId === CREDIT_PACK_PRICE_ID) ||
    (creditPackConfigured("sepa") && priceId === CREDIT_PACK_EUR_PRICE_ID)
  ) {
    return CREDIT_PACK_CREDITS;
  }
  return 0;
}

export {
  CREDIT_PACK_CREDITS,
  CREDIT_PACK_PRICE_CENTS,
  CREDIT_PACK_PRICE_DOLLARS,
  CREDIT_PACK_PRICE_LABEL,
  CREDIT_PACK_EUR_PRICE_LABEL,
  getCreditPackPriceId,
};
